export const SCROLL_OFFSET = 100
export const LUCKY_WHEEL_SECTION = {
  code: 'lucky-wheel-section',
  title: 'Lucky Wheel',
}

export const landingSection = {
  games: {
    code: 'game-section,',
    title: 'Games',
  },
  spin: LUCKY_WHEEL_SECTION,

  vipBenefit: {
    code: 'vip-benefit-section,',
    title: 'VIP Club',
  },
  benefit: {
    code: 'benefit-section,',
    title: 'Why Us',
  },
  bonuses: {
    code: 'bonuses-section,',
    title: 'Bonuses',
  },
  receiveVoucher: {
    code: 'receive-voucher-section,',
    title: 'Voucher',
  },
  start: {
    code: 'start-section,',
    title: 'Get Started',
  },
  streamer: {
    code: 'streamer-section,',
    title: 'Videos',
  },
  welcome: { code: 'welcome-section,', title: 'Welcome' },
  welcomeBonus: {
    code: 'welcome-bonus-section,',
    title: 'Welcome',
  },
}

export const GAME_TAGS = {
  ROULETTE: 'roulette',
  BLACKJACK: 'blackjack',
  ALL_GAME: 'all_game',
  SLOTS: 'slots',
  VIRTUAL_SPORTS: 'virtual-sports',
  NEW_RELEASE: 'new-release',
  BACCARAT: 'baccarat',
  TABLE_GAMES: 'table-games',
  GAME_SHOWS: 'game-shows',
  HOT: 'hot',
  FEATURE_BUY: 'feature-buy',
  SCRATCH_CARDS: 'scratch-cards',
  LIVE_CASINO: 'live-casino',
}

export const CASUAL_GAMER_GAME_TAGS = [
  GAME_TAGS.SLOTS,
  GAME_TAGS.BACCARAT,
  GAME_TAGS.ROULETTE,
  GAME_TAGS.GAME_SHOWS,
  GAME_TAGS.TABLE_GAMES,
  GAME_TAGS.VIRTUAL_SPORTS,
]

export const HIGH_ROLLER_GAME_TAGS = [
  GAME_TAGS.SLOTS,
  GAME_TAGS.BACCARAT,
  GAME_TAGS.ROULETTE,
  GAME_TAGS.GAME_SHOWS,
  GAME_TAGS.TABLE_GAMES,
]

export const BONUS_HUNTER_GAME_TAGS = [
  GAME_TAGS.SLOTS,
  GAME_TAGS.BACCARAT,
  GAME_TAGS.ROULETTE,
  GAME_TAGS.GAME_SHOWS,
  GAME_TAGS.TABLE_GAMES,
  GAME_TAGS.VIRTUAL_SPORTS,
]

export const cryptoEnthusiastSpinReward = [
  {
    amount: '1',
    currency: 'BTC',
    network: -100,
    id: 1,
  },
  {
    amount: '10',
    currency: 'USDT',
    network: 97,
    id: 2,
    isAvailable: true,
  },
  {
    amount: '10',
    currency: 'BNB',
    network: 56,
    id: 3,
  },
  {
    amount: '30',
    currency: 'USDT',
    network: 97,
    id: 4,
    isAvailable: true,
  },
  {
    amount: '80',
    currency: 'USDT',
    network: 97,
    id: 5,
    isAvailable: true,
  },
  {
    amount: '5',
    currency: 'ETH',
    network: 1,
    id: 6,
  },
  {
    amount: '20',
    currency: 'USDT',
    network: 97,
    id: 7,
    isAvailable: true,
  },
  {
    amount: '100',
    currency: 'LTC',
    network: -18,
    id: 8,
  },
  {
    amount: '40',
    currency: 'USDT',
    network: 97,
    id: 9,
    isAvailable: true,
  },
  {
    amount: '60',
    currency: 'USDT',
    network: 97,
    id: 10,
    isAvailable: true,
  },
  {
    amount: '100',
    currency: 'SOL',
    network: -1,
    id: 11,
  },
  {
    amount: '100',
    currency: 'USDT',
    network: 97,
    id: 12,
    isAvailable: true,
  },
]

export const casualGamerSpinRewards = [
  {
    amount: '100 FS',
    id: 1,
  },
  {
    amount: '20',
    currency: 'USDT',
    network: 97,
    id: 2,
    isAvailable: true,
  },
  {
    amount: '150% Deposit',
    id: 3,
  },
  {
    amount: '60',
    currency: 'USDT',
    network: 97,
    id: 4,
    isAvailable: true,
  },
  {
    amount: '300% Deposit',
    id: 5,
  },
  {
    amount: '10',
    currency: 'USDT',
    network: 97,
    id: 6,
    isAvailable: true,
  },
  {
    amount: '50 FS',
    id: 7,
  },
  {
    amount: '30',
    currency: 'USDT',
    network: 97,
    id: 8,
    isAvailable: true,
  },
  {
    amount: '40',
    currency: 'USDT',
    network: 97,
    id: 9,
    isAvailable: true,
  },
  {
    amount: '200% Deposit',
    id: 10,
  },
  {
    amount: '80',
    currency: 'USDT',
    network: 97,
    id: 11,
    isAvailable: true,
  },
  {
    amount: '100',
    currency: 'USDT',
    network: 97,
    id: 12,
    isAvailable: true,
  },
]

export const highRollerSpinRewards = [
  {
    amount: '1',
    currency: 'BTC',
    network: -100,
    id: 1,
  },
  {
    amount: '150',
    currency: 'USDT',
    network: 97,
    id: 2,
    isAvailable: true,
  },
  {
    amount: '10',
    currency: 'BNB',
    network: 56,
    id: 3,
  },
  {
    amount: '500',
    currency: 'USDT',
    network: 97,
    id: 4,
  },
  {
    amount: '100',
    currency: 'SOL',
    network: -1,
    id: 5,
  },
  {
    amount: '50',
    currency: 'USDT',
    network: 97,
    id: 6,
    isAvailable: true,
  },
  {
    amount: '100',
    currency: 'USDT',
    network: 97,
    id: 7,
    isAvailable: true,
  },
  {
    amount: '5',
    currency: 'ETH',
    network: 1,
    id: 8,
  },
  {
    amount: '200',
    currency: 'USDT',
    network: 97,
    id: 9,
    isAvailable: true,
  },
  {
    amount: '300',
    currency: 'USDT',
    network: 97,
    id: 10,
  },
  {
    amount: '100',
    currency: 'LTC',
    network: -18,
    id: 11,
  },
  {
    amount: '1000',
    currency: 'USDT',
    network: 97,
    id: 12,
  },
]

export const bonusHunterSpinRewards = [
  {
    amount: '1',
    currency: 'BTC',
    network: -100,
    id: 1,
  },
  {
    amount: '100',
    currency: 'USDT',
    network: 97,
    id: 2,
    isAvailable: true,
  },
  {
    amount: '10',
    currency: 'BNB',
    network: 56,
    id: 3,
  },
  {
    amount: '300',
    currency: 'USDT',
    network: 97,
    id: 4,
  },
  {
    amount: '100',
    currency: 'SOL',
    network: -1,
    id: 5,
  },
  {
    amount: '50',
    currency: 'USDT',
    network: 97,
    id: 6,
    isAvailable: true,
  },
  {
    amount: '5',
    currency: 'ETH',
    network: 1,
    id: 7,
  },
  {
    amount: '150',
    currency: 'USDT',
    network: 97,
    id: 8,
    isAvailable: true,
  },
  {
    amount: '200',
    currency: 'USDT',
    network: 97,
    id: 9,
    isAvailable: true,
  },
  {
    amount: '100',
    currency: 'LTC',
    network: -18,
    id: 10,
  },
  {
    amount: '500',
    currency: 'USDT',
    network: 97,
    id: 11,
  },
  {
    amount: '1000',
    currency: 'USDT',
    network: 97,
    id: 12,
  },
]
